import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table,
    Input,
    TabContent, TabPane, Nav, NavItem, NavLink, CardText
} from "reactstrap"
import Shimmer from "react-shimmer-effect";
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
// import UpdateBloc from './Blocs/UpdateBloc'
import ManajerialComponent from './Form/ManajerialComponent'
import TeknisComponent from './Form/TeknisComponent'
import SosioComponent from './Form/SosioComponent'

// updateBloc = new UpdateBloc()
class UpdateView extends Component {
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            list: [],
            dataForm: {},
            isLoading: 0,
            activeTab: '1',
        }

    }
    
    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }
    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.indexBloc.fetchDetail(query)
    }

    componentDidMount(){
        this.loadDetail()
        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })


    }
    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.updateChannel?.unsubscribe()
    }
    
    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/standar_kompetensi.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Edit Standar Kompetensi</CardTitle>
                            <hr/>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Jabatan <span className="text-danger">*</span>
                                </Label>
                                <Col md="5">
                                    {
                                    this.state.detail ?
                                    <Input
                                        name="position_name"
                                        placeholder="Nama Jabatan"
                                        errorMessage="Masukkan Jabatan"
                                        type="text"
                                        className="form-control"
                                        value={detail?.position_name}
                                        validate={{ required: { value: true } }}
                                        readOnly={true}
                                    />:
                                    <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                    }
                                    <Input
                                        name="tipe"
                                        type="hidden"
                                        id="tipe"
                                        value="1"
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                    Standar Kompetensi 
                                </Label>
                            </Row>
                                
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '1' })}
                                            onClick={() => { this.toggle('1'); }}
                                        >
                                            Manajerial
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '2' })}
                                            onClick={() => { this.toggle('2'); }}
                                        >
                                            Teknis
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '3' })}
                                            onClick={() => { this.toggle('3'); }}
                                        >
                                            Sosio Kultural
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col sm="12">
                                                <div style={{padding:'15px'}}>
                                                    <ManajerialComponent uuid={this.props.uuid}/>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col sm="12">
                                                <TeknisComponent uuid={this.props.uuid}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col sm="12">
                                            <SosioComponent uuid={this.props.uuid}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>

                        </CardBody>
                    </Card>
                </Container>
                
            </Fragment>
        )
    }


}

export default UpdateView
